import { createFileRoute } from '@tanstack/react-router';
import { AdminFollowUpDetail } from '@/admin/followups/AdminFollowUpDetail';

export const Route = createFileRoute('/admin/follow-ups/$followUpId')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  component: FollowUpPage,
});

function FollowUpPage() {
  const { followUpId } = Route.useParams();
  return <AdminFollowUpDetail followUpId={Number(followUpId)} />;
}
